module.exports = __webpack_public_path__ + "static/media/Harshad_Gillurkar.e5ad358e.pdf";